// API calls of the multi-tenant work package "money" (per-company amount / date formatting).
import { apiRequest } from '../api';
import type { Region } from '../region';

/** Each firm this login may see or switch to → its effective region (server: routes/money.ts). */
export const fetchCompanyRegions = (): Promise<{ regions: Record<string, Partial<Region>> }> =>
  apiRequest('GET', '/money/regions');
